/**
 * Lignes à envoyer au PATCH lignes-poids — uniquement les poids réellement modifiés.
 */

export function effectivePoidsGrammesFromItem(item) {
  const reel = Number(item?.poidsReel) || 0;
  if (reel > 0) return reel;
  const souhaite = Number(item?.poidsSouhaite) || 0;
  return souhaite > 0 ? souhaite : 0;
}

export function buildModifiedLignesPoidsReel(poidsDrafts, produits = []) {
  const byId = new Map((produits || []).map((p) => [p.id, p]));
  const lignes = [];
  for (const [ligneId, draft] of Object.entries(poidsDrafts || {})) {
    const item = byId.get(ligneId);
    const poidsReel = Number(draft?.poidsReel);
    if (!Number.isFinite(poidsReel) || poidsReel <= 0) continue;
    const baseline = effectivePoidsGrammesFromItem(item);
    if (baseline > 0 && Math.abs(poidsReel - baseline) < 0.001) continue;
    lignes.push({ ligneId, poidsReel });
  }
  return lignes;
}
